import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@shared/models/User';

@Pipe({
    name: 'userName'
})
export class UserNamePipe implements PipeTransform {

    transform(userId: string | undefined, users: User[]): string {
        if (!userId) return 'Unknown';
        if (!users || users.length === 0) return userId;

        const user = users.find(u => u.username === userId || u._id === userId);
        if (user) {
            const nameParts = [user.firstName, user.lastName].filter(v => !!v);
            return nameParts.length > 0 ? nameParts.join(' ') : user.username;
        }
        return userId;
    }
}
